/* eslint-disable @typescript-eslint/naming-convention */
import { ObjectOptions } from 'api/requestUtils'

export const getOptions = (accessToken?: string): ObjectOptions =>
  accessToken
    ? { headers: { Authorization: `Bearer ${accessToken}` } }
    : { credentials: 'include' }

export const baseUri = '/api/trips'
export const baseTemplatesUri = `${baseUri}/templates`
